import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import App from './App';
import './CSS/index.css'; // if you have global styles
import './i18n'; // Import i18n to initialize before rendering

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);